module.exports = __webpack_public_path__ + "img/aqua.60a3cc43.png";